import React, { useState, useEffect } from "react";
import inquiryValidation from "../helpers/inquiryValidation";
import {
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  Button,
  Input,
  Select,
  MenuItem
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import request from "superagent";
import propTypes from "prop-types";

import infoIcon from "../../../../images/info-24px.svg";
import { Mixpanel } from "../../../../components/shared/Mixpanel";

const $ = window.jQuery;

export default function Inquiry(props) {
  const [state, setState] = useState({
    companyName: (props.profile && props.profile.company) || "",
    email: (props.profile && props.profile.email) || "",
    firstName: (props.profile && props.profile.firstName) || "",
    intent: "",
    lastName: (props.profile && props.profile.lastName) || "",
    phoneNumber: (props.profile && props.profile.phoneNumber) || "",
    country: "",
    showTitleName: "",
    advertisementMedia: "",
    digitalMedia: "",
    nonprofitMedia: "",
    newsletter: "",
    tvMedia: ""
  });

  let token = props.userToken;

  useEffect(() => {
    showHideRecaptchaDiv(false);
    return () => showHideRecaptchaDiv(true);
  }, []);

  const disableButtons = () => {
    let buttons = document.getElementsByClassName("inquiry-button");

    for (let i = 0; i < buttons.length; i++) {
      buttons[i].disabled = true;
    }
  };

  const handleChange = (event, name) => {
    const value = event.target.value;
    setState((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleChangeCheck = (event, name) => {
    const value = event.target.checked;
    setState((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const buildInquiry = () => {
    let videos = [];

    const mediaUsageAdvertisement = state.advertisementMedia,
      mediaUsageDigital = state.digitalMedia,
      mediaUsageNonProfit = state.nonprofitMedia,
      mediaUsageTvFilm = state.tvMedia;

    Object.keys(props.videos).map((c) => {
      let item = props.videos[c];

      videos.push({
        jmId: item.jmId,
        rate: "1.00",
        exclusiveUntil: false
      });

      return videos;
    });

    let inquiry = {
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      showTitleName: state.showTitleName,
      phoneNumber: state.phoneNumber,
      companyName: state.companyName,
      country: state.country,
      intent: state.intent,
      mediaUsageAdvertisement: mediaUsageAdvertisement,
      mediaUsageDigital: mediaUsageDigital,
      mediaUsageNonProfit: mediaUsageNonProfit,
      mediaUsageTvFilm: mediaUsageTvFilm,
      videos: videos
    };
    return inquiry;
  };

  const submitForm = async (e) => {
    e.preventDefault();

    let userId =
      props.profile && props.profile.id !== undefined ? props.profile.id : "Non Logged In";

    if (inquiryValidation(state, userId)) {
      if (props.lead === "") {
        props.newInquiry(buildInquiry());

        Mixpanel.track("Inquiry submission");
      } else {
        let formData = JSON.stringify($("#myform").serializeArray());

        Mixpanel.track(
          "Inquiry submission",
          {
            category: props.videos[0] && props.videos[0].category
          },
          {
            send_immediately: true
          }
        );

        props.newLead(formData);
      }
      if (state.newsletter) {
        submitSubscribeFormSubmission();
      }
      disableButtons();
    }
  };

  const showHideRecaptchaDiv = (hidden) => {
    const recaptchaDiv = document.querySelector(".grecaptcha-badge");
    if (hidden) {
      recaptchaDiv && recaptchaDiv.classList.add("hidden");
    } else {
      recaptchaDiv && recaptchaDiv.classList.remove("hidden");
    }
  };

  const submitSubscribeFormSubmission = () => {
    const isProd = process.env.REACT_APP_FUNK_URL === "https://www.jukinmedia.com";
    const url = isProd
      ? "https://j4x7fdvbfj.execute-api.us-west-2.amazonaws.com/prod/subscribe"
      : "https://j4x7fdvbfj.execute-api.us-west-2.amazonaws.com/dev/subscribe";

    const listID = isProd ? "de6a17ccfb" : "1a945a9abd";

    request
      .post(url)
      .send({
        mailchimpListID: listID,
        data: {
          email_address: state.email,
          status: "subscribed",
          merge_fields: {
            MMERGE2: state.firstName,
            MMERGE3: state.lastName,
            MMERGE6: state.phoneNumber
          },
          tags: ["LP-INQUIRY"]
        }
      })
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
  };

  return (
    <div className="inquiry-form-container">
      <h2>Let’s Talk</h2>
      <div className="fixed-width">
        <p>
          Complete all required inquiry fields &amp; one of our friendly licensing professionals
          will reach out to you shortly.
        </p>
      </div>

      <form
        id="myform"
        name="inquiry-form"
        autoComplete="off"
        method="post"
        onSubmit={(e) => {
          submitForm(e);
        }}
        data-token={token}
      >
        {props.lead !== "" && (
          <div className="hidden">
            <input type="hidden" name="oid" value={process.env.REACT_APP_SALESFORCE_ACCOUNT_ID} />
            <input
              type="hidden"
              name="retURL"
              value={`${process.env.REACT_APP_FUNK_URL}/licensing/inquiry`}
            />
            <input
              type="hidden"
              name={process.env.REACT_APP_SALESFORCE_JV_ID}
              value={props.videos && props.videos.length > 0 && props.videos[0].jmId}
            />
            <label htmlFor="lead_source">Lead Source</label>
            <select id="lead_source" name="lead_source">
              <option value={props.lead}>{props.lead}</option>
            </select>
          </div>
        )}

        <p className="required">All fields required.</p>
        <div className="fixed-width">
          <FormControl>
            <h6>Contact</h6>
            <InputLabel htmlFor="first_name">First Name</InputLabel>
            <Input
              required
              className="checkout-first-name"
              id="first_name"
              name="first_name"
              type="text"
              inputProps={{
                maxLength: 64
              }}
              defaultValue={
                props.profile && props.profile.firstName !== "" ? props.profile.firstName : ""
              }
              onChange={(e) => handleChange(e, "firstName")}
              autoFocus
            />
            <p id="fnError" className="hidden formError">
              Please enter your first name.
            </p>
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="last_name">Last Name</InputLabel>
            <Input
              required
              className="checkout-last-name"
              id="last_name"
              name="last_name"
              type="text"
              inputProps={{
                maxLength: 64
              }}
              defaultValue={
                props.profile && props.profile.lastName !== "" ? props.profile.lastName : ""
              }
              onChange={(e) => handleChange(e, "lastName")}
            />
            <p id="lnError" className="hidden formError">
              Please enter your last name.
            </p>
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="email">Email</InputLabel>
            <Input
              required
              className="checkout-email"
              id="email"
              type="email"
              name="email"
              inputProps={{
                maxLength: 256
              }}
              defaultValue={props.profile && props.profile.email !== "" ? props.profile.email : ""}
              onChange={(e) => handleChange(e, "email")}
            />
            <p id="emailError" className="hidden formError">
              Please enter your email.
            </p>
          </FormControl>
          <FormControl className="inquiry-phone">
            <InputLabel htmlFor="phone">Phone Number</InputLabel>
            <Input
              required
              className="checkout-phone"
              id="phone"
              type="text"
              name="phone"
              inputProps={{
                maxLength: 25
              }}
              defaultValue={
                props.profile && props.profile.phoneNumber !== "" ? props.profile.phoneNumber : ""
              }
              onChange={(e) => handleChange(e, "phoneNumber")}
            />
            <p id="phoneError" className="hidden formError">
              Please enter your phone number.
            </p>
            <Tooltip
              title="Your phone number will allow us to process your inquiry
                  quickly and provide immediate assistance."
              placement="bottom"
            >
              <img src={infoIcon} alt="Phone number" />
            </Tooltip>
          </FormControl>
          <div className="flex">
            <FormControl>
              <InputLabel htmlFor="city">Work City</InputLabel>
              <Input
                required
                className="checkout-work"
                id="city"
                type="text"
                name="city"
                inputProps={{
                  maxLength: 255
                }}
                onChange={(e) => handleChange(e, "companyName")}
              />
              <p id="wpError" className="hidden formError">
                Please enter where you work.
              </p>
            </FormControl>
            <FormControl className="country">
              <InputLabel htmlFor="country_code">Work Country</InputLabel>
              <Select
                value={state.country}
                onChange={(e) => handleChange(e, "country")}
                inputProps={{ name: "country_code", id: "country_code" }}
              >
                <MenuItem value="">--None--</MenuItem>
                <MenuItem value="AD">Andorra</MenuItem>
                <MenuItem value="AE">United Arab Emirates</MenuItem>
                <MenuItem value="AF">Afghanistan</MenuItem>
                <MenuItem value="AG">Antigua And Barbuda</MenuItem>
                <MenuItem value="AI">Anguilla</MenuItem>
                <MenuItem value="AL">Albania</MenuItem>
                <MenuItem value="AM">Armenia</MenuItem>
                <MenuItem value="AN">Netherlands Antilles</MenuItem>
                <MenuItem value="AO">Angola</MenuItem>
                <MenuItem value="AQ">Antarctica</MenuItem>
                <MenuItem value="AR">Argentina</MenuItem>
                <MenuItem value="AS">American Samoa</MenuItem>
                <MenuItem value="AT">Austria</MenuItem>
                <MenuItem value="AU">Australia</MenuItem>
                <MenuItem value="AW">Aruba</MenuItem>
                <MenuItem value="AX">Aland Islands</MenuItem>
                <MenuItem value="AZ">Azerbaijan</MenuItem>
                <MenuItem value="BA">Bosnia And Herzegovina</MenuItem>
                <MenuItem value="BB">Barbados</MenuItem>
                <MenuItem value="BD">Bangladesh</MenuItem>
                <MenuItem value="BE">Belgium</MenuItem>
                <MenuItem value="BF">Burkina Faso</MenuItem>
                <MenuItem value="BG">Bulgaria</MenuItem>
                <MenuItem value="BH">Bahrain</MenuItem>
                <MenuItem value="BI">Burundi</MenuItem>
                <MenuItem value="BJ">Benin</MenuItem>
                <MenuItem value="BL">Saint Barthélemy</MenuItem>
                <MenuItem value="BM">Bermuda</MenuItem>
                <MenuItem value="BN">Brunei Darussalam</MenuItem>
                <MenuItem value="BO">Bolivia, Plurinational State of</MenuItem>
                <MenuItem value="BR">Brazil</MenuItem>
                <MenuItem value="BS">Bahamas</MenuItem>
                <MenuItem value="BT">Bhutan</MenuItem>
                <MenuItem value="BV">Bouvet Island</MenuItem>
                <MenuItem value="BW">Botswana</MenuItem>
                <MenuItem value="BY">Belarus</MenuItem>
                <MenuItem value="BZ">Belize</MenuItem>
                <MenuItem value="CA">Canada</MenuItem>
                <MenuItem value="CC">Cocos (Keeling) Islands</MenuItem>
                <MenuItem value="CD">Congo, The Democratic Republic of the</MenuItem>
                <MenuItem value="CF">Central African Republic</MenuItem>
                <MenuItem value="CG">Congo</MenuItem>
                <MenuItem value="CH">Switzerland</MenuItem>
                <MenuItem value="CI">Cote D'Ivoire</MenuItem>
                <MenuItem value="CK">Cook Islands</MenuItem>
                <MenuItem value="CL">Chile</MenuItem>
                <MenuItem value="CM">Cameroon</MenuItem>
                <MenuItem value="CN">China</MenuItem>
                <MenuItem value="CO">Colombia</MenuItem>
                <MenuItem value="CR">Costa Rica</MenuItem>
                <MenuItem value="CU">Cuba</MenuItem>
                <MenuItem value="CV">Cape Verde</MenuItem>
                <MenuItem value="CW">Curaçao</MenuItem>
                <MenuItem value="CX">Christmas Island</MenuItem>
                <MenuItem value="CY">Cyprus</MenuItem>
                <MenuItem value="CZ">Czech Republic</MenuItem>
                <MenuItem value="DE">Germany</MenuItem>
                <MenuItem value="DJ">Djibouti</MenuItem>
                <MenuItem value="DK">Denmark</MenuItem>
                <MenuItem value="DM">Dominica</MenuItem>
                <MenuItem value="DO">Dominican Republic</MenuItem>
                <MenuItem value="DZ">Algeria</MenuItem>
                <MenuItem value="EC">Ecuador</MenuItem>
                <MenuItem value="EE">Estonia</MenuItem>
                <MenuItem value="EG">Egypt</MenuItem>
                <MenuItem value="EH">Western Sahara</MenuItem>
                <MenuItem value="ER">Eritrea</MenuItem>
                <MenuItem value="ES">Spain</MenuItem>
                <MenuItem value="ET">Ethiopia</MenuItem>
                <MenuItem value="FI">Finland</MenuItem>
                <MenuItem value="FJ">Fiji</MenuItem>
                <MenuItem value="FK">Falkland Islands (Malvinas)</MenuItem>
                <MenuItem value="FM">Micronesia</MenuItem>
                <MenuItem value="FO">Faroe Islands</MenuItem>
                <MenuItem value="FR">France</MenuItem>
                <MenuItem value="GA">Gabon</MenuItem>
                <MenuItem value="GB">United Kingdom</MenuItem>
                <MenuItem value="GD">Grenada</MenuItem>
                <MenuItem value="GE">Georgia</MenuItem>
                <MenuItem value="GF">French Guiana</MenuItem>
                <MenuItem value="GG">Guernsey</MenuItem>
                <MenuItem value="GH">Ghana</MenuItem>
                <MenuItem value="GI">Gibraltar</MenuItem>
                <MenuItem value="GL">Greenland</MenuItem>
                <MenuItem value="GM">Gambia</MenuItem>
                <MenuItem value="GN">Guinea</MenuItem>
                <MenuItem value="GP">Guadeloupe</MenuItem>
                <MenuItem value="GQ">Equatorial Guinea</MenuItem>
                <MenuItem value="GR">Greece</MenuItem>
                <MenuItem value="GS">South Georgia And The South Sandwich Islands</MenuItem>
                <MenuItem value="GT">Guatemala</MenuItem>
                <MenuItem value="GU">Guam</MenuItem>
                <MenuItem value="GW">Guinea-Bissau</MenuItem>
                <MenuItem value="GY">Guyana</MenuItem>
                <MenuItem value="HK">Hong Kong</MenuItem>
                <MenuItem value="HM">Heard Island And Mcdonald Islands</MenuItem>
                <MenuItem value="HN">Honduras</MenuItem>
                <MenuItem value="HR">Croatia</MenuItem>
                <MenuItem value="HT">Haiti</MenuItem>
                <MenuItem value="HU">Hungary</MenuItem>
                <MenuItem value="ID">Indonesia</MenuItem>
                <MenuItem value="IE">Ireland</MenuItem>
                <MenuItem value="IL">Israel</MenuItem>
                <MenuItem value="IM">Isle Of Man</MenuItem>
                <MenuItem value="IN">India</MenuItem>
                <MenuItem value="IO">British Indian Ocean Territory</MenuItem>
                <MenuItem value="IQ">Iraq</MenuItem>
                <MenuItem value="IR">Iran, Islamic Republic of</MenuItem>
                <MenuItem value="IS">Iceland</MenuItem>
                <MenuItem value="IT">Italy</MenuItem>
                <MenuItem value="JE">Jersey</MenuItem>
                <MenuItem value="JM">Jamaica</MenuItem>
                <MenuItem value="JO">Jordan</MenuItem>
                <MenuItem value="JP">Japan</MenuItem>
                <MenuItem value="KE">Kenya</MenuItem>
                <MenuItem value="KG">Kyrgyzstan</MenuItem>
                <MenuItem value="KH">Cambodia</MenuItem>
                <MenuItem value="KI">Kiribati</MenuItem>
                <MenuItem value="KM">Comoros</MenuItem>
                <MenuItem value="KN">Saint Kitts And Nevis</MenuItem>
                <MenuItem value="KP">Korea, Democratic People's Republic Of</MenuItem>
                <MenuItem value="KR">Korea</MenuItem>
                <MenuItem value="KW">Kuwait</MenuItem>
                <MenuItem value="KY">Cayman Islands</MenuItem>
                <MenuItem value="KZ">Kazakhstan</MenuItem>
                <MenuItem value="LA">Lao People's Democratic Republic</MenuItem>
                <MenuItem value="LB">Lebanon</MenuItem>
                <MenuItem value="LC">Saint Lucia</MenuItem>
                <MenuItem value="LI">Liechtenstein</MenuItem>
                <MenuItem value="LK">Sri Lanka</MenuItem>
                <MenuItem value="LR">Liberia</MenuItem>
                <MenuItem value="LS">Lesotho</MenuItem>
                <MenuItem value="LT">Lithuania</MenuItem>
                <MenuItem value="LU">Luxembourg</MenuItem>
                <MenuItem value="LV">Latvia</MenuItem>
                <MenuItem value="LY">Libya</MenuItem>
                <MenuItem value="MA">Morocco</MenuItem>
                <MenuItem value="MC">Monaco</MenuItem>
                <MenuItem value="MD">Moldova, Republic of</MenuItem>
                <MenuItem value="ME">Montenegro</MenuItem>
                <MenuItem value="MF">Saint Martin (French Part)</MenuItem>
                <MenuItem value="MG">Madagascar</MenuItem>
                <MenuItem value="MH">Marshall Islands</MenuItem>
                <MenuItem value="MK">Macedonia, The Former Yugoslav Republic Of</MenuItem>
                <MenuItem value="ML">Mali</MenuItem>
                <MenuItem value="MM">Myanmar</MenuItem>
                <MenuItem value="MN">Mongolia</MenuItem>
                <MenuItem value="MO">Macao</MenuItem>
                <MenuItem value="MP">Northern Mariana Islands</MenuItem>
                <MenuItem value="MQ">Martinique</MenuItem>
                <MenuItem value="MR">Mauritania</MenuItem>
                <MenuItem value="MS">Montserrat</MenuItem>
                <MenuItem value="MT">Malta</MenuItem>
                <MenuItem value="MU">Mauritius</MenuItem>
                <MenuItem value="MV">Maldives</MenuItem>
                <MenuItem value="MW">Malawi</MenuItem>
                <MenuItem value="MX">Mexico</MenuItem>
                <MenuItem value="MY">Malaysia</MenuItem>
                <MenuItem value="MZ">Mozambique</MenuItem>
                <MenuItem value="NA">Namibia</MenuItem>
                <MenuItem value="NC">New Caledonia</MenuItem>
                <MenuItem value="NE">Niger</MenuItem>
                <MenuItem value="NF">Norfolk Island</MenuItem>
                <MenuItem value="NG">Nigeria</MenuItem>
                <MenuItem value="NI">Nicaragua</MenuItem>
                <MenuItem value="NL">Netherlands</MenuItem>
                <MenuItem value="NO">Norway</MenuItem>
                <MenuItem value="NP">Nepal</MenuItem>
                <MenuItem value="NR">Nauru</MenuItem>
                <MenuItem value="NU">Niue</MenuItem>
                <MenuItem value="NZ">New Zealand</MenuItem>
                <MenuItem value="OM">Oman</MenuItem>
                <MenuItem value="PA">Panama</MenuItem>
                <MenuItem value="PE">Peru</MenuItem>
                <MenuItem value="PF">French Polynesia</MenuItem>
                <MenuItem value="PG">Papua New Guinea</MenuItem>
                <MenuItem value="PH">Philippines</MenuItem>
                <MenuItem value="PK">Pakistan</MenuItem>
                <MenuItem value="PL">Poland</MenuItem>
                <MenuItem value="PM">Saint Pierre And Miquelon</MenuItem>
                <MenuItem value="PN">Pitcairn</MenuItem>
                <MenuItem value="PR">Puerto Rico</MenuItem>
                <MenuItem value="PS">Palestinian Territory, Occupied</MenuItem>
                <MenuItem value="PT">Portugal</MenuItem>
                <MenuItem value="PW">Palau</MenuItem>
                <MenuItem value="PY">Paraguay</MenuItem>
                <MenuItem value="QA">Qatar</MenuItem>
                <MenuItem value="RE">Reunion</MenuItem>
                <MenuItem value="RO">Romania</MenuItem>
                <MenuItem value="RS">Serbia</MenuItem>
                <MenuItem value="RU">Russia Federation</MenuItem>
                <MenuItem value="RW">Rwanda</MenuItem>
                <MenuItem value="SA">Saudi Arabia</MenuItem>
                <MenuItem value="SB">Solomon Islands</MenuItem>
                <MenuItem value="SC">Seychelles</MenuItem>
                <MenuItem value="SD">Sudan</MenuItem>
                <MenuItem value="SE">Sweden</MenuItem>
                <MenuItem value="SG">Singapore</MenuItem>
                <MenuItem value="SH">Saint Helena, Ascension And Tristan Da Cunha</MenuItem>
                <MenuItem value="SI">Slovenia</MenuItem>
                <MenuItem value="SJ">Svalbard And Jan Mayen</MenuItem>
                <MenuItem value="SK">Slovakia</MenuItem>
                <MenuItem value="SL">Sierra Leone</MenuItem>
                <MenuItem value="SM">San Marino</MenuItem>
                <MenuItem value="SN">Senegal</MenuItem>
                <MenuItem value="SO">Somalia</MenuItem>
                <MenuItem value="SR">Suriname</MenuItem>
                <MenuItem value="SS">South Sudan</MenuItem>
                <MenuItem value="ST">Sao Tome And Principe</MenuItem>
                <MenuItem value="SV">El Salvador</MenuItem>
                <MenuItem value="SY">Syrian Arab Republic</MenuItem>
                <MenuItem value="SZ">Swaziland</MenuItem>
                <MenuItem value="TC">Turks And Caicos Islands</MenuItem>
                <MenuItem value="TD">Chad</MenuItem>
                <MenuItem value="TF">French Southern Territories</MenuItem>
                <MenuItem value="TG">Togo</MenuItem>
                <MenuItem value="TH">Thailand</MenuItem>
                <MenuItem value="TJ">Tajikistan</MenuItem>
                <MenuItem value="TK">Tokelau</MenuItem>
                <MenuItem value="TL">Timor-Leste</MenuItem>
                <MenuItem value="TM">Turkmenistan</MenuItem>
                <MenuItem value="TN">Tunisia</MenuItem>
                <MenuItem value="TO">Tonga</MenuItem>
                <MenuItem value="TR">Turkey</MenuItem>
                <MenuItem value="TT">Trinidad And Tobago</MenuItem>
                <MenuItem value="TV">Tuvalu</MenuItem>
                <MenuItem value="TW">Taiwan, Province of China</MenuItem>
                <MenuItem value="TZ">Tanzania, United Republic of</MenuItem>
                <MenuItem value="UA">Ukraine</MenuItem>
                <MenuItem value="UG">Uganda</MenuItem>
                <MenuItem value="UM">United States Minor Outlying Islands</MenuItem>
                <MenuItem value="US">United States of America</MenuItem>
                <MenuItem value="UY">Uruguay</MenuItem>
                <MenuItem value="UZ">Uzbekistan</MenuItem>
                <MenuItem value="VA">Holy See (Vatican City State)</MenuItem>
                <MenuItem value="VC">Saint Vincent And The Grenadines</MenuItem>
                <MenuItem value="VE">Venezuela, Bolivarian Republic Of</MenuItem>
                <MenuItem value="VG">Virgin Islands, British</MenuItem>
                <MenuItem value="VI">Virgin Islands</MenuItem>
                <MenuItem value="VN">Vietnam</MenuItem>
                <MenuItem value="VU">Vanuatu</MenuItem>
                <MenuItem value="WF">Wallis And Futuna</MenuItem>
                <MenuItem value="WS">Samoa</MenuItem>
                <MenuItem value="XK">Kosovo</MenuItem>
                <MenuItem value="YE">Yemen</MenuItem>
                <MenuItem value="YT">Mayotte</MenuItem>
                <MenuItem value="ZA">South Africa</MenuItem>
                <MenuItem value="ZM">Zambia</MenuItem>
                <MenuItem value="ZW">Zimbabwe</MenuItem>
              </Select>
            </FormControl>
          </div>

          <FormControl>
            <InputLabel htmlFor={process.env.REACT_APP_SALESFORCE_SHOW_ID}>
              Project Name or Show
            </InputLabel>
            <Input
              required
              className="checkout-project"
              id={process.env.REACT_APP_SALESFORCE_SHOW_ID}
              name={process.env.REACT_APP_SALESFORCE_SHOW_ID}
              inputProps={{
                maxLength: 256
              }}
              onChange={(e) => handleChange(e, "showTitleName")}
            />
            <p id="pjError" className="hidden formError">
              Please enter the name of the show / project.
            </p>
          </FormControl>
        </div>

        <div className="usage-info">
          <h6>Usage</h6>
          <FormControlLabel
            className="inquiry-checkboxes"
            control={
              <Checkbox
                onChange={(e) => handleChangeCheck(e, "tvMedia")}
                color="default"
                name={process.env.REACT_APP_SALESFORCE_INTEND_ID}
                value="Entertainment"
              />
            }
            label={
              <p>
                <span>Entertainment </span> - TV Show, Movie, Other Shows
              </p>
            }
          />

          <FormControlLabel
            className="inquiry-checkboxes"
            control={
              <Checkbox
                onChange={(e) => handleChangeCheck(e, "advertisementMedia")}
                color="default"
                name={process.env.REACT_APP_SALESFORCE_INTEND_ID}
                value="Advertisement"
              />
            }
            label={
              <p>
                <span>Advertisement</span> - TV / Digital Commercial, Branded Content, Corporate
              </p>
            }
          />

          <FormControlLabel
            className="inquiry-checkboxes"
            control={
              <Checkbox
                onChange={(e) => handleChangeCheck(e, "digitalMedia")}
                color="default"
                name={process.env.REACT_APP_SALESFORCE_INTEND_ID}
                value="Digital Editorial"
              />
            }
            label={
              <p>
                <span>Digital Editorial</span> - Web Publication, Publisher’s Social Media
              </p>
            }
          />

          <FormControlLabel
            className="inquiry-checkboxes"
            control={
              <Checkbox
                onChange={(e) => handleChangeCheck(e, "nonprofitMedia")}
                color="default"
                name={process.env.REACT_APP_SALESFORCE_INTEND_ID}
                value="Other"
              />
            }
            label={
              <p>
                <span>Other</span> - Personal, Non-Profit, Educational, Religious, Community,
                Government
              </p>
            }
          />

          <p id="usageError" className="hidden formError">
            Please select usage.
          </p>

          <div className="fixed-width">
            <FormControl>
              <InputLabel
                htmlFor={process.env.REACT_APP_SALESFORCE_ADDITIONAL_DEAIL_ID}
                className="inquiry-intend"
              >
                How do you intend to use our content?
              </InputLabel>
              <Input
                required
                id={process.env.REACT_APP_SALESFORCE_ADDITIONAL_DEAIL_ID}
                name={process.env.REACT_APP_SALESFORCE_ADDITIONAL_DEAIL_ID}
                margin="dense"
                multiline
                onChange={(e) => handleChange(e, "intent")}
                inputProps={{
                  maxLength: 5000
                }}
              />
            </FormControl>
          </div>
        </div>

        <div className="inewsletter-checkbox">
          <FormControlLabel
            className="inquiry-checkboxes"
            control={
              <Checkbox
                onChange={(e) => handleChangeCheck(e, "newsletter")}
                color="default"
                name="newsletter"
              />
            }
            label="Email me recommended videos & special offers."
          />
        </div>

        <div className="place-inquiry">
          <Button variant="contained" className="inquiry-button" type="submit">
            Place Inquiry
          </Button>
        </div>
      </form>
    </div>
  );
}

Inquiry.propTypes = {
  newInquiry: propTypes.func,
  profile: propTypes.object
};
